import type React from "react";
import { useState } from "react";
import { useCreatePost } from "@/hooks/channel/useCreatePost";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { useToast } from "@/hooks/ui/use-toast";

interface PostFormProps {
	channelId: string | undefined;
}

export const PostForm: React.FC<PostFormProps> = ({ channelId }) => {
	const [content, setContent] = useState("");
	const { createPost, loading } = useCreatePost();
	const { toast } = useToast();

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		if (!content.trim() || !channelId) return;

		try {
			await createPost({
				channelId,
				content: content.trim(),
			});
			setContent("");
			toast({
				title: "投稿を作成しました",
				variant: "default",
			});
		} catch (error) {
			toast({
				title: "投稿の作成に失敗しました",
				variant: "destructive",
			});
		}
	};

	// channelIdがない場合は何も表示しない
	if (!channelId) return null;

	return (
		<form onSubmit={handleSubmit} className="space-y-4">
			<Textarea
				value={content}
				onChange={(e) => setContent(e.target.value)}
				placeholder="メッセージを入力..."
				className="min-h-[100px]"
			/>
			<Button type="submit" disabled={loading || !content.trim()}>
				{loading ? "投稿中..." : "投稿する"}
			</Button>
		</form>
	);
};
